// PrivateRoute.tsx
import type React from 'react';
import { Route, useLocation } from 'wouter';
import { useAuth } from '@/contexts/auth.ctx.tsx';

interface PrivateRouteProps {
  path: string;
  component: React.FC;
  redirectTo?: string;
  minAuthLevel?: 'YENTA' | 'MANAGER' | 'AGENT' | 'FREE';
}

const AuthLevelMap = {
  'FREE': 1,
  'AGENT': 2,
  'MANAGER': 3,
  'YENTA': 4,
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ path, component: Component, redirectTo='/login', minAuthLevel='FREE' }) => {
  const { isAuthenticated, authLevel, signout } = useAuth();
  const [, setLocation] = useLocation();

  if (!isAuthenticated) {
    setLocation(redirectTo);
    return null;
  }

  // If the auth level is less than the minimum requirement
  if(AuthLevelMap[authLevel ?? 'FREE'] < AuthLevelMap[minAuthLevel]) {
    signout();
    setLocation(redirectTo);
    return null;
  }

  return <Route path={path} component={Component} />;
};

export default PrivateRoute;
